const spendingLimits = {
  'spendingLimits.channels': 'Canais',
  'spendingLimits.errorChangeChannel': 'Erro na atualização do canal',
  'spendingLimits.value': 'Valor limite',
  'spendingLimits.confirm': 'Confirmar',
  'spendingLimits.limitValueUpdateSuccess': 'Valor limite atualizado!',
  'spendingLimits.resetIn': 'Reseta em',
};

export default spendingLimits;
